import { DatePicker } from '@mui/lab';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { IdentificationDocument } from 'shell/view-models/personal-data';
import Foreign from './foreign';
import Italian from './italian';

interface IdentificationFormProps {
  onChange: (
    key: keyof IdentificationDocument,
    value: IdentificationDocument[keyof IdentificationDocument]
  ) => void;
  onFieldsChange: (values: IdentificationDocument) => void;
  values?: IdentificationDocument;
  disabled?: boolean;
  errors?: FormikErrors<IdentificationDocument>;
  touched?: FormikTouched<IdentificationDocument>;
}
function IdentificationDocumentApplicantForm({
  onChange,
  onFieldsChange,
  values,
  disabled,
  errors,
  touched,
}: IdentificationFormProps): React.ReactElement {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Evento"
            id="isForeign"
            defaultValue={false}
            value={values?.isForeign || false}
            onChange={() => {
              onFieldsChange({
                ...values,
                isForeign: !values?.isForeign,
                municipality: null,
                placeForeign: undefined,
              });

              return;
            }}
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Carta d'identità"
              disabled={disabled}
            />
            <FormControlLabel value="true" control={<Radio />} label="Altro" disabled={disabled} />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          fullWidth
          aria-label="Numero"
          label="Numero *"
          id="number"
          type="text"
          value={values?.documentNumber || ''}
          onChange={(event) => onChange('documentNumber', event.target.value)}
          disabled={disabled}
          error={Boolean(errors?.documentNumber) && touched?.documentNumber}
          helperText={errors?.documentNumber}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data rilascio *"
          aria-label="Data rilascio"
          value={values?.issuedDate || null}
          onChange={(date) => onChange('issuedDate', date)}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="issuedDate"
              error={Boolean(errors?.issuedDate) && touched?.issuedDate}
              helperText={errors?.issuedDate}
              fullWidth
            />
          )}
        />
      </Grid>
      {values?.isForeign ? (
        <Foreign
          disabled={disabled}
          values={values}
          onChange={onChange}
          errors={errors}
          touched={touched}
        />
      ) : (
        <Italian
          disabled={disabled}
          values={values}
          onChange={onChange}
          errors={errors}
          touched={touched}
        />
      )}
    </Grid>
  );
}

IdentificationDocumentApplicantForm.displayName =
  'Applicant Identification Document Form Component ';

const IdentificationDocumentForm = memo(IdentificationDocumentApplicantForm);

export default IdentificationDocumentForm;
